module.exports = __webpack_public_path__ + "static/MaryleboneResidences-957922551ae523f756c19e263d61b2f6.jpeg";